import React from 'react';
import R from 'ramda';
import { connect } from 'react-redux';
import {
  getUploadDialogVisible,
  getUploadComplete,
  getUploadProgress,
} from 'submission/submissionReducer';
import { Dialog } from 'react-toolbox/lib/dialog';
import { FontIcon } from 'react-toolbox/lib/font_icon';
import { ProgressBar } from 'react-toolbox/lib/progress_bar';
import styles from './UploadDialog.css';
import theme from 'shared-styles/DialogTheme.css';

import {
  ACKNOWLEDGE_SUBMISSION_COMPLETE,
  CANCEL_UPLOAD,
} from 'submission/submissionActions';

const UploadDialog = ({ visible, complete, progress, onCancel, onOk }) =>
  <Dialog
    actions={[
      {
        label: complete ? 'OK' : 'Cancel',
        onClick: complete ? onOk : onCancel,
      },
    ]}
    active={visible}
    onEscKeyDown={onCancel}
    title={complete ? 'Submitted' : 'Submitting...'}
    theme={theme}
  >
    <div className={styles.body}>
      {complete
        ? <div className={styles.circle}>
            <FontIcon className={styles.doneIcon} value="check" />
            <span className={styles.completeLabel}>Complete</span>
          </div>
        : progress < 100
          ? <div className={styles.circle}>
              <span className={styles.percentText}>
                {progress}%
              </span>
              <span className={styles.completeLabel}>Uploading</span>
            </div>
          : <div className={styles.circle}>
              <ProgressBar
                className={styles.progressBar}
                type="circular"
                mode="indeterminate"
              />
              <span className={styles.completeLabel}>Processing</span>
            </div>}
    </div>
  </Dialog>;

const mapState = R.pipe(
  R.path(['submission']),
  R.applySpec({
    visible: getUploadDialogVisible,
    complete: getUploadComplete,
    progress: getUploadProgress,
  }),
);

const mapDispatch = dispatch => ({
  onCancel: () => dispatch({ type: CANCEL_UPLOAD }),
  onOk: () => dispatch({ type: ACKNOWLEDGE_SUBMISSION_COMPLETE }),
});

export default connect(mapState, mapDispatch)(UploadDialog);



// WEBPACK FOOTER //
// ./src/submission/components/UploadDialog.js